//import Moment from "moment";

const getCount = (state) => {
	return state.equipamentos.length;
}

const ultimaAtualizacaoListaEquipamentos = (state) => {
	if (state.ultimaAtualizacaoListaPeriodicidades == null) {
		return true;
	}
	else if(!state.equipamentos)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.equipamentos.length == 0 ||
			hour - state.ultimaAtualizacaoListaEquipamentos.getHours() > 0
		);
	}
}
export default {
	getCount,
	ultimaAtualizacaoListaEquipamentos
}